// import { Report55Container } from "../../../containers/SupportSystem/Reports/Report55Container";
import { ListReportViewSupport4Container } from "../../../containers/SupportSystem/Reports/ListReportViewSupport4Container";
export function ListReportViewSupport4Page() {
    return (
        <ListReportViewSupport4Container />
    );

}